export const GET_AI_PROMPT_SUGGESTIONS_REQUEST = 'GET_AI_PROMPT_SUGGESTIONS_REQUEST';
export const GET_AI_PROMPT_SUGGESTIONS_DONE = 'GET_AI_PROMPT_SUGGESTIONS_DONE';
export const GET_AI_PROMPT_SUGGESTIONS_FAILED = 'GET_AI_PROMPT_SUGGESTIONS_FAILED';
export const SET_SUGGESTIONS_TO_DISPLAY = 'SET_SUGGESTIONS_TO_DISPLAY';
